import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insidePages } from '../data/insidePages';
import { OFFER_ANCHOR } from '../data/constants';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement | null>(null);
  const [active, setActive] = useState(0);
  const scrollTo = useCallback((index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(index, insidePages.length - 1));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setActive(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const next = Math.round(track.scrollLeft / track.clientWidth);
      setActive(Math.max(0, Math.min(next, insidePages.length - 1)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="border-b border-line bg-panel py-8 sm:py-10" data-id="element-88" data-mp="a4r482evt8ys">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-89" data-mp="60ayc159q1jk">
        <h2 className="text-center text-[26px] font-bold leading-none text-white sm:text-[40px]" data-id="element-90" data-mp="k0lqd7ibdm6b">
          Look <span className="text-brandorange" data-id="element-91" data-mp="f195utex0r6w">inside</span>
        </h2>
        <p className="mt-2 text-center font-display text-[15px] uppercase leading-tight text-white sm:text-[20px]" data-id="element-92" data-mp="ezy22tlgzjfs">
          Discover What's Inside Motorcycle Diagnostic Pro™
        </p>
        <p className="mx-auto mt-2 max-w-[820px] text-center text-[13.5px] font-medium leading-snug text-metal sm:text-[16px]" data-id="element-93" data-mp="3igel7trb05g0">
          Engine troubleshooting, fuel-system references, electrical testing,
          charging diagnostics, ignition and ECU systems, sensor guidance,
          drivetrain troubleshooting and ready-to-use professional fault-finding
          workflows.
        </p>

        <div className="relative mt-5" data-id="element-94" data-mp="2zrq5rnblasbm">
          <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto overscroll-x-contain" aria-label="Interior pages carousel" data-id="element-95" data-mp="13p3lhzcokaoa">
            {insidePages.map((page, i) => <div key={page.src} className="w-full shrink-0 snap-center px-1" role="group" aria-roledescription="slide" aria-label={`Page ${i + 1} of ${insidePages.length}`} data-id="element-96" data-mp="1dfgcoaf0323e" data-mpi={i}>
                <a href={OFFER_ANCHOR} className="block border-2 border-line bg-carbon p-1.5 sm:p-2" data-id="element-97" data-mp="pq3skfi4x9mb">
                  <img src={page.src} alt={page.alt} loading={i === 0 ? 'eager' : 'lazy'} className="mx-auto w-full max-w-[720px] object-contain" data-id="element-98" data-mp="ypqwp9290tj2" />
                </a>
              </div>)}
          </div>

          <button type="button" onClick={() => scrollTo(active - 1)} disabled={active === 0} aria-label="Previous page" className="absolute left-0 top-1/2 -translate-y-1/2 border border-line bg-carbon/90 p-2 text-white transition-colors duration-150 ease-out hover:bg-brandorange disabled:pointer-events-none disabled:opacity-30 sm:p-3" data-id="element-99" data-mp="2k8kuyrrppxvi">
            <ChevronLeftIcon className="h-5 w-5" strokeWidth={3} data-id="element-100" data-mp="21iw5vfajlbo2" />
          </button>
          <button type="button" onClick={() => scrollTo(active + 1)} disabled={active === insidePages.length - 1} aria-label="Next page" className="absolute right-0 top-1/2 -translate-y-1/2 border border-line bg-carbon/90 p-2 text-white transition-colors duration-150 ease-out hover:bg-brandorange disabled:pointer-events-none disabled:opacity-30 sm:p-3" data-id="element-101" data-mp="1wjjimtfre2ky">
            <ChevronRightIcon className="h-5 w-5" strokeWidth={3} data-id="element-102" data-mp="3hxnx3ovyccvs" />
          </button>
        </div>

        <div className="mt-3 flex items-center justify-center gap-2" data-id="element-103" data-mp="3p0ugafuxqx57">
          {insidePages.map((page, i) => <button key={page.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === active} className={`h-2 transition-[width,background-color] duration-150 ease-out ${i === active ? 'w-7 bg-brandorange' : 'w-2 bg-line hover:bg-metal'}`} data-id="element-104" data-mp="3txksut7j7alv" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}